import React from "react";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";
import Select from "@/components/Select";
import { Deployment } from "./Deployments";

interface Props {
  deployments: Deployment[];
  selectedDeploymentId: number | null;
  onSelect(id: number): void;
  onAddNew(): void;
  showAddButton: boolean;
}

export default function DeploymentSelector({
  deployments,
  selectedDeploymentId,
  onSelect,
  onAddNew,
  showAddButton
}: Props) {
  if (!Array.isArray(deployments) || deployments.length === 0) {
    return null;
  }

  const options = deployments.reduce(
    (acc, d) => {
      acc[d.id.toString()] = d.displayName || `Deployment ${d.deploymentId}`;
      return acc;
    },
    {} as Record<string, string>
  );

  return (
    <div className="flex items-center gap-3 mb-4 w-[750px] self-center">
      <label className="text-sm font-medium text-slate-700 whitespace-nowrap">
        Deployment:
      </label>
      <div className="flex-1">
        <Select
          options={options}
          value={selectedDeploymentId?.toString() ?? null}
          onChange={(value) => onSelect(Number(value))}
        />
      </div>
      {showAddButton && (
        <PrimaryBlueButton
          label="+ Add New"
          onClick={onAddNew}
        />
      )}
    </div>
  );
}
